export const ENUM_QUESTION_TYPE = {
  DESCRIPTIVE_SHORT_ESSAY: 'short_text',
  PARAGRAPH: 'paragraph',
  RADIO: 'radio',
  SELECT_QUESTION: 'SELECT_QUESTION',
  CHECKBOX: 'checkbox',
  DROPDOWN: 'dropdown',
  DATE: 'date',
  MEASUREMENT: 'measurement',
  IMAGES: 'images',
  VIDEOS: 'videos',
};

export const ENUM_SURVEY_STATUS = {
  DRAFT: 'draft',
  PUBLIC: 'public',
  PRIVATE: 'private',
};

export const ENUM_USER_STATUS = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  NEW: 'NEW',
};

export const ENUM_SURVEY_TYPE = {
  EXAM: 'exam',
  SDQ: 'sdq',
  VIDEO: 'video',
  MCHAT: 'mchat',
  DIPOLE: 'dipole',
  YABUNAKA: 'yabunaka',
  KINDL: 'kindl',
  PARENTING_SCALE: 'parenting_scale',
  CURIOSITY: 'curiosity',
  SAFETY_ASSESSMENT: 'safety_assessment',
};

// Types whose questionnaire is chosen by period: the exam questionnaire by
// health-checkup timing, SDQ by age band. The others have a single questionnaire.
export const SURVEY_TYPES_WITH_PERIOD = [ENUM_SURVEY_TYPE.EXAM, ENUM_SURVEY_TYPE.SDQ];

export const ENUM_IMAGE_LAYOUT = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center',
};

export const ENUM_ACTIVE_CHECKBOX = {
  EXPLANATION: 'explanation',
  INCLUDE_YEAR: 'include_year',
};

export const ENUM_PASSWORD_CREATE_ERROR = {
  LENGTH: 1,
  HAS_UPPERCASE: 2,
  HAS_LOWERCASE: 3,
  HAS_NUMBER: 4,
  HAS_SYMBOLS: 5,
  HAS_FULL_WIDTH: 6,
  HAS_SYMBOLS_REQUIRED: 7,
};

export const ENUM_STEP_REGISTER = {
  ENTER_ACCOUNT_INFO: 1,
  CONFIRM_ACCOUNT_INFO: 2,
};

export const ENUM_STEP_PROFILE = {
  PROFILE: 0,
  UPDATE_EMAIL: 1,
  UPDATE_PASSWORD: 2,
  UPDATE_PROFILE: 3,
};

export const ENUM_TYPE_OPTION = {
  RADIO: 1,
  CHECKBOX: 2,
  DROPDOWN: 3,
};

export const ENUM_TYPE_ACTION = {
  DELETE: 'delete',
  CREATE: 'create',
  UPDATE: 'update',
};

export const ENUM_TYPE_QUESTION = {
  THREE_YEAR_OLD: 'THREE_YEAR_OLD',
  TWO_WEEKS_OLD: 'TWO_WEEKS_OLD',
  ONE_MONTH_OLD: 'ONE_MONTH_OLD',
  TWO_MONTHS_OLD: 'TWO_MONTHS_OLD',
  FIVE_MONTHS_OLD: 'FIVE_MONTHS_OLD',
  SIX_SEVEN_MONTHS_OLD: 'SIX_SEVEN_MONTHS_OLD',
  EIGHT_MONTHS_OLD: 'EIGHT_MONTHS_OLD',
  NINE_TEN_MONTHS_OLD: 'NINE_TEN_MONTHS_OLD',
  ELEVEN_MONTHS_OLD: 'ELEVEN_MONTHS_OLD',
  ONE_YEAR_OLD: 'ONE_YEAR_OLD',
  ONE_YEAR_SIX_MONTHS_OLD: 'ONE_YEAR_SIX_MONTHS_OLD',
  TWO_YEARS_OLD: 'TWO_YEARS_OLD',
  FOUR_YEARS_OLD: 'FOUR_YEARS_OLD',
  FIVE_YEARS_OLD: 'FIVE_YEARS_OLD',
  SIX_YEARS_OLD: 'SIX_YEARS_OLD',
  // SDQ age bands
  TWO_TO_FOUR_YEARS_OLD: 'TWO_TO_FOUR_YEARS_OLD',
  FOUR_TO_SEVENTEEN_YEARS_OLD: 'FOUR_TO_SEVENTEEN_YEARS_OLD',
};

export const ENUM_TYPE_DOWNLOAD = {
  CSV: 'csv',
  EXCEL: 'excel',
};

export const ENUM_ROLE_USER = {
  ADMIN: 'ADMIN',
  USER: 'USER',
};

export const ENUM_TYPE_CREATE_OPTIONS = {
  CHILD_5_YEAR_OLD_CHECKUP: 'CHILD_5_YEAR_OLD_CHECKUP',
  CHILD_OTHER: 'CHILD_OTHER',
};

export const ENUM_TYPE_PUBLIC_PERIOD_SETTING = {
  START_TIME_NOT_SET: 'START_TIME_NOT_SET',
  START_TIME_SET: 'START_TIME_SET',
  END_TIME_NOT_SET: 'END_TIME_NOT_SET',
  END_TIME_SET: 'END_TIME_SET',
};

export const ENUM_ERROR_SETTING_TIME_TYPE = {
  START_TIME_BEFORE_NOW: 'start_time_before_now',
  END_TIME_BEFORE_START_TIME: 'end_time_before_start_time',
};

export const ENUM_TYPE_SURVEY = {
  SDQ: 'sdq',
  YABUNAKA: 'yabunaka',
  MCHAT: 'mchat',
  DIPOLE: 'dipole',
  KINDL: 'kindl',
  PARENTING_SCALE: 'parenting_scale',
  CURIOSITY: 'curiosity',
  SAFETY_ASSESSMENT: 'safety_assessment',
};

export const ENUM_TYPE_SURVEY_RESPONSE = {
  SDQ: 'sdq_survey',
  YABUNAKA: 'yabunaka_survey',
  MCHAT: 'sdq_mchat',
  DIPOLE: 'sdq_dipole',
  KINDL: 'kindl_survey',
  PARENTING_SCALE: 'parenting_scale_survey',
  CURIOSITY: 'curiosity_survey',
  SAFETY_ASSESSMENT: 'safety_assessment_survey',
};

export const ENUM_TYPE_VIEW_SURVEY = {
  PREVIEW: 'preview', // View on mobile
  VIEW_ONLY: 'view_only',
};
